// @flow

export class BaseService<T> {
  store: T

  getStore: () => T

  constructor(store: T) {
    this.store = store
  }

  bindListeners = () => {
    throw new Error('You must specify bindListeners method in your class')
  }

  getStore(): T {
    return this.store
  }
}
